import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from 'trpc-react-native-ui';

import formatDurationValue from '../../../../lib/usage-formatters/duration-usage-formatter';
import formatSmsValue from '../../../../lib/usage-formatters/sms-usage-formatter';
import formatMonetaryValue from '../../../../lib/usage-formatters/monetary-usage-formatter';
import formatVolumeValue from '../../../../lib/usage-formatters/volume-usage-formatter';
import I18n from '../../../../lib/i18n';

export default class TopUpDoughnutLegend extends Component {
  styles = getStyles();
  getMainLegend() {
    if (!this.props.current) return '';
    let whatsLeft;
    switch (this.props.unitType) {
      case 'DURATION':
        whatsLeft = this.props.current === 0 ? I18n.t('nothing') : formatDurationValue(this.props.current);
        break;
      case 'NUMBER':
      case 'SMS':
        whatsLeft = this.props.current === 0 ? I18n.t('nothing') : formatSmsValue(this.props.current);
        break;
      case 'MONETARY':
        whatsLeft = this.props.current === 0 ? I18n.t('nothing') : formatMonetaryValue(this.props.current);
        break;
      case 'VOLUME':
        whatsLeft = this.props.current === 0 ? I18n.t('nothing') : formatVolumeValue(this.props.current);
        break;
      default:
        whatsLeft = this.props.current === 0 ? I18n.t('nothing') : this.props.current;
    }
    return I18n.t('left', { value: whatsLeft });
  }

  render() {
    const styles = this.styles;
    let { textColor } = this.props;

    return (
      <View style={styles.legend}>
        <Text style={[styles.legendCurrent, this.props.isActive ? { color: textColor } : {}]}>
          {this.getMainLegend()}
        </Text>
        {this.props.endDate && (
          <Text style={styles.endDateLegend}>
            {I18n.t('TopUpDoughnutLegend.until', { endDate: this.props.endDate })}
          </Text>
        )}
      </View>
    );
  }
}

TopUpDoughnutLegend.propTypes = {
  current: PropTypes.any,
  isActive: PropTypes.bool,
  unitType: PropTypes.string,
  endDate: PropTypes.string,
};

function getStyles() {
  return StyleSheet.create({
    legend: {
      top: 10,
      marginBottom: 8,
      justifyContent: 'center',
      alignItems: 'center',
    },
    legendCurrent: {
      fontSize: 14,
      fontWeight: '500',
      textAlign: 'center',
    },
    endDateLegend: {
      fontSize: 12,
      fontWeight: '300',
      textAlign: 'center',
    },
  });
}
